import type { SVGProps } from 'react'
const LineRefreshCw = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			d="M14 10h5.75c.69 0 1.25-.56 1.25-1.25V3h-1.5v4.03A8.98 8.98 0 0 0 12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9a9.01 9.01 0 0 0 8.695-6.67l-1.45-.39A7.51 7.51 0 0 1 12 19.5c-4.135 0-7.5-3.365-7.5-7.5S7.865 4.5 12 4.5c2.805 0 5.34 1.55 6.635 4H14z"
		/>
	</svg>
)
export { LineRefreshCw }
